export default __webpack_public_path__ + "static/media/logging.74dfcec9.yaml";